import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<nav>\n  <MenuFastboot::Item @menu={{this.menu}} />\n</nav>",{ moduleName: "frontend/components/menu-fastboot/template.hbs" })